import React, { useEffect, useState } from 'react';
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import { setStorage, getStorage } from '../../../Utils/common';
import { saveReferenceDetails } from '../../../Utils/api';
import Button from '../../../components/ui/Button';
import { FormWrapper } from '../../../components/loan/style';
import { FaTrash } from "react-icons/fa";
import { toast } from "react-hot-toast";

const ReferenceDetails = () => {
    const [loading, setLoading] = useState(false);
    const [adding, setIsAdding] = useState(false);
    const [progressBar] = useState(getStorage("step_percent"));
    const [referenceData, setReferenceData] = useState({
        name: '',
        relation: '',
        mobile: '',
    });
    const relationOptions = {
        "1": "Parents",
        "2": "Relatives",
        "3": "Friends",
        "4": "Colleague",
        "5": "Sibling",
        "6": "Other",
    };

    const [referenceList, setReferenceList] = useState([]);
    const [error, serError] = useState('')

    const showMessage = (message) => {
        toast.success(message);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setReferenceData((prev) => ({ ...prev, [name]: value }));
    };


    const addReference = (e) => {
        setIsAdding(true)
        e.preventDefault();
        const { name, relation, mobile } = referenceData;
        const phoneRegex = /^[0-9]{10}$/;

        if (!name.trim() || !relation.trim() || !mobile.trim()) {
            setIsAdding(false)
            return showMessage('Please fill all the fields')
        }
        if (!phoneRegex.test(mobile)) {
            setIsAdding(false)
            return showMessage("Please enter valid mobile number")
        }
        if (referenceList.length >= 5) {
            setIsAdding(false)
            return showMessage("You can't give reference more then 5 people")
        }
        if (referenceList.some(ref => ref.mobile === mobile)) {
            setIsAdding(false)
            return showMessage("This mobile number is already added as a reference")
        }

        setTimeout(() => {
            setReferenceList(prev => [...prev, referenceData]);
            localStorage.setItem("references", JSON.stringify([...referenceList, referenceData]));
            setReferenceData({
                name: '',
                relation: '',
                mobile: '',
            });

            setIsAdding(false);
        }, 1000);
    };


    const list = localStorage.getItem("references");
    useEffect(() => {
        if (list) {
            setReferenceList(JSON.parse(list));
        }
    }, []);


    const handleSubmit = async (e) => {
        if (referenceList.length < 2) {
            return alert("Please add at least two references")
        }

        if (referenceList.length > 5) {
            return alert("You can't give reference more then 5 people")
        }
        e.preventDefault();

        try {
            setLoading(true);
            const param = {
                profile_id: getStorage("cust_profile_id") || "",
                references: referenceList,
                event_name: "reference_details",
            };

            const res = await saveReferenceDetails(param);
            setLoading(false);
            console.log(res);

            if (res.data.Status === 2) {
                alert(res.data.Message)
            }
        } catch (error) {
            showMessage("Error saving reference details:" + error.message);
        }
    };

    const deleteReference = (index) => {
        const updatedList = referenceList.filter((_, i) => i !== index);
        setReferenceList(updatedList);
        localStorage.setItem("references", JSON.stringify(updatedList));
    }

    return (
        <div>
            <ProgressBar value={`${progressBar}%`}>
                <div></div>
            </ProgressBar><br />

            <form
                className="max-w-5xl m-auto w-full bg-white p-6 sm:p-10 rounded-xl shadow-sm"
            >
                <div className='mb-5'>
                    <h2 className="font-semibold text-2xl text-black">
                        Reference Details
                    </h2>
                    <p className="text-gray-600 mt-2 leading-relaxed">
                        Please provide a reference. This can be
                        <span className="font-medium"> family, friends, or colleagues</span>
                        {' '}who are able to verify your details.
                    </p>
                </div>

                <div className="mt-8 flex flex-col gap-6">

                    <FormWrapper>
                        <div className='flex flex-col gap-6'>
                            <div className="flex flex-col md:flex-row gap-6">
                                <div className="flex-1">
                                    <label htmlFor="referenceName" className="block text-black">
                                        Reference <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        id="referenceName"
                                        name="name"
                                        type="text"
                                        value={referenceData.name}
                                        onChange={handleChange}
                                        required
                                        className="mt-2 w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#4FA0FF]"
                                        placeholder="Enter name"
                                    />
                                </div>

                                <div className="flex-1">

                                    <label htmlFor="referenceType" className="block text-black">
                                        Relation <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        id="referenceType"
                                        name="relation"
                                        value={referenceData.relation}
                                        onChange={handleChange}
                                        required
                                        className="mt-2 w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#4FA0FF]"
                                    >
                                        <option value="">Select</option>
                                        <option value="1">Parents</option>
                                        <option value="2">Relatives</option>
                                        <option value="3">Friends</option>
                                        <option value="4">Colleague</option>
                                        <option value="5">Sibling</option>
                                        <option value="6">Other</option>
                                    </select>
                                </div>
                            </div>


                            <div className="flex-1">
                                <label htmlFor="referenceMobile" className="block text-black">
                                    Mobile <span className="text-red-500">*</span>
                                </label>
                                <input
                                    id="referenceMobile"
                                    name="mobile"
                                    type="tel"
                                    value={referenceData.mobile}
                                    onChange={handleChange}
                                    required
                                    className="mt-2 w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#4FA0FF]"
                                    placeholder="Enter mobile number"
                                />
                            </div>
                        </div>
                        <div className='flex justify-center mt-10'>

                            <button className='!bg-green-600 w-full max-w-[400px] rounded-lg inline !border-0 hover:!text-white'
                                disabled={adding}
                                onClick={addReference}
                            >
                                {adding ? (
                                    <div className="flex items-center gap-2 justify-center">
                                        <svg
                                            className="animate-spin h-5 w-5 text-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                        >
                                            {/* Simplified path - faster rendering */}
                                            <path
                                                fill="currentColor"
                                                d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                                opacity="0.25"
                                            />
                                            <path
                                                fill="currentColor"
                                                d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
                                            />
                                        </svg>
                                        Adding...
                                    </div>) : 'Add Reference'}
                            </button>

                        </div>
                    </FormWrapper>
                </div>
            </form>


            <div className="max-w-5xl m-auto mt-10">
                <h3 className="text-xl font-semibold mb-4 text-gray-800">Submitted Reference</h3>
                <div className="overflow-x-auto rounded-lg shadow-md">
                    <table className="w-full border-collapse bg-white rounded-lg overflow-hidden">
                        <thead className="bg-[#4FA0FF] text-white">
                            <tr>
                                <th className="p-4 text-left text-md whitespace-nowrap">No.</th>
                                <th className="p-4 text-left text-md whitespace-nowrap">Reference</th>
                                <th className="p-4 text-left text-md whitespace-nowrap">Relation</th>
                                <th className="p-4 text-left text-md whitespace-nowrap text-center">Mobile No</th>
                                <th className="p-4 text-left text-md whitespace-nowrap text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {referenceList.length !== 0 ? (
                                referenceList.map((referenceList, index) => (
                                    <tr className="hover:bg-gray-50 transition" key={index}>
                                        <td className="p-4 border-b border-gray-200 font-medium text-black">{index + 1}.</td>
                                        <td className="p-4 border-b border-gray-200 font-medium text-md">{referenceList.name}</td>
                                        <td className="p-4 border-b border-gray-200 font-medium text-md capitalize">{relationOptions[referenceList.relation]}</td>
                                        <td className="p-4 border-b border-gray-200 font-medium text-md text-center">{referenceList.mobile}</td>
                                        <td className="p-4 border-b border-gray-200 font-medium text-md text-center"><FaTrash className='text-red-500 mx-auto cursor-pointer'
                                            onClick={() => { deleteReference(index) }} /></td>
                                    </tr>
                                ))) : <tr><td colSpan='5' className='text-center'>
                                    Please add some refrences</td></tr>}
                            {referenceList.length >= 2 && (
                                <tr>
                                    <td colSpan='5' className='text-center p-4'>
                                        <div className='max-w-[400px] my-5 m-auto'>
                                            <Button title="Submit" onClick={handleSubmit} loading={loading} />
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ReferenceDetails;